const config = {
    url: 'https://api.unsplash.com/',
    clientKey: 'xKQD5DVp7mIsiOFzkKgZNEHIlhClbX2epOylf8mqbLg'
}


export default config;